import { render, staticRenderFns } from "./myOrderList.vue?vue&type=template&id=0b830eaf&scoped=true"
import script from "./myOrderList.vue?vue&type=script&lang=js"
export * from "./myOrderList.vue?vue&type=script&lang=js"
import style0 from "./myOrderList.vue?vue&type=style&index=0&id=0b830eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b830eaf",
  null
  
)

export default component.exports